/* istanbul ignore file */

import Amplify from '@noths/amplify';

import { shouldSignInAsQAAdmin } from 'src/settings';
import { logError } from 'src/utils/logError';

export const getSession = async () => {
  try {
    return await Amplify.Auth.currentSession();
  } catch {
    if (shouldSignInAsQAAdmin()) {
      const { signInAsQAAdmin } = await import('./signInAsQAAdmin');
      await signInAsQAAdmin();

      return Amplify.Auth.currentSession();
    }

    logError('No current user session');

    return null;
  }
};
